import Footer from 'components/core/Footer';
import { useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  selectFunc,
  selectFuncLoading,
  signOutFunc,
  updateFunc,
} from 'redux/features/auth/authSlice';
import history from 'services/history';
import validarCPF from 'validar-cpf';

const validarCelular = (celular) => {
  const apenasNumeros = celular.replace(/\D/g, '');
  return apenasNumeros.length === 13 && apenasNumeros.startsWith('55');
};

export default function FormFuncionario() {
  const dispatch = useDispatch();
  const func = useSelector(selectFunc);
  const loading = useSelector(selectFuncLoading);
  const [validated, setValidated] = useState(false);
  const tipo = history.location.state?.tipo || 'celular';

  const handleSubmitCelular = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const cpf = form.formCPF.value;
    const celular = form.formCelular.value;

    if (!validarCPF(cpf)) {
      toast.error('CPF inválido');
      return;
    }

    if (!validarCelular(celular)) {
      toast.error('Celular deve estar no formato: 5514935006168 (55 + DDD + 9 dígitos)');
      return;
    }

    try {
      await dispatch(updateFunc({ cpf, celular })).unwrap();
      toast.success('Celular alterado com sucesso!');
      history.push('/perfil-funcionario');
    } catch (error) {
      console.error('Erro ao alterar celular:', error);
    }
  };

  const handleSubmitSenha = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const cpf = form.formCPF.value;
    const senha = form.formSenhaNova.value;
    const confirmPassword = form.formConfirmSenha.value;

    if (!validarCPF(cpf)) {
      toast.error('CPF inválido');
      return;
    }

    if (senha !== confirmPassword) {
      toast.warning('As senhas não correspondem.');
      return;
    }

    if (senha.length < 4) {
      toast.warning('A senha deve ter no mínimo 4 caracteres.');
      return;
    }

    try {
      await dispatch(updateFunc({ cpf, senha })).unwrap();
      toast.success('Senha alterada com sucesso! Faça login novamente.');
      dispatch(signOutFunc());
      history.push('/funcionario/login');
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f0f4f8, #d9e2ec)' }}>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={6}>
            <Card className="shadow">
              <Card.Body>
                {tipo === 'celular' ? (
                  <>
                    <h4 className="mb-4">Alterar Celular</h4>
                    <Form noValidate validated={validated} onSubmit={handleSubmitCelular}>
                      <Form.Group controlId="formCPF" className="mb-3">
                        <Form.Label>CPF</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Digite seu CPF"
                          defaultValue={func?.cpf || ''}
                          disabled
                        />
                        <Form.Control.Feedback type="invalid">
                          Por favor, informe seu CPF.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group controlId="formCelular" className="mb-3">
                        <Form.Label>Novo Celular</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="5514935006168"
                          defaultValue={func?.celular || ''}
                          onChange={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '');
                          }}
                        />
                        <Form.Text className="text-muted">
                          Formato: 55 + DDD (2 dígitos) + 9 dígitos do número
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">
                          Por favor, informe um celular válido.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Button
                        type="submit"
                        variant="primary"
                        className="rounded-pill w-100 mb-2"
                        disabled={loading}
                      >
                        {loading ? 'Salvando...' : 'Salvar'}
                      </Button>
                      <Button
                        type="button"
                        variant="secondary"
                        className="rounded-pill w-100"
                        onClick={() => history.push('/perfil-funcionario')}
                        disabled={loading}
                      >
                        Cancelar
                      </Button>
                    </Form>
                  </>
                ) : (
                  <>
                    <h4 className="mb-4">Alterar Senha</h4>
                    <Form noValidate validated={validated} onSubmit={handleSubmitSenha}>
                      <Form.Group controlId="formCPF" className="mb-3">
                        <Form.Label>CPF</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Digite seu CPF"
                          defaultValue={func?.cpf || ''}
                          disabled
                        />
                        <Form.Control.Feedback type="invalid">
                          Por favor, informe seu CPF.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group controlId="formSenhaNova" className="mb-3">
                        <Form.Label>Nova Senha</Form.Label>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Digite sua nova senha (mínimo 4 caracteres)"
                          minLength="4"
                        />
                        <Form.Control.Feedback type="invalid">
                          Por favor, informe uma nova senha (mínimo 4 caracteres).
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group controlId="formConfirmSenha" className="mb-3">
                        <Form.Label>Confirmar Senha</Form.Label>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Confirme sua nova senha"
                          minLength="4"
                        />
                        <Form.Control.Feedback type="invalid">
                          Por favor, confirme sua senha.
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Button
                        type="submit"
                        variant="primary"
                        className="rounded-pill w-100 mb-2"
                        disabled={loading}
                      >
                        {loading ? 'Salvando...' : 'Alterar Senha'}
                      </Button>
                      <Button
                        type="button"
                        variant="secondary"
                        className="rounded-pill w-100"
                        onClick={() => history.push('/perfil-funcionario')}
                        disabled={loading}
                      >
                        Cancelar
                      </Button>
                    </Form>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}
